
/**
 * 콘텐츠 타입
 */
export type CreateCourseDraft201SectionsItemLecturesItemContentType = typeof CreateCourseDraft201SectionsItemLecturesItemContentType[keyof typeof CreateCourseDraft201SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
